<div class="ui-kit-rows-layout" data-qa-block="user-permissions">
  <div class="ui-kit-block-title" translate data-qa="block-title">group.account</div>

  <div
    class="ui-kit-grey-text"
    data-qa="empty-list-text"
    *ngIf="getDisplayedSelectedPermissions(selectedPermissions).length === 0"
    translate
  >
    group.account.description
  </div>

  <div
    class="ui-kit-ellipsis-text"
    data-qa="options-list"
    *ngIf="getDisplayedSelectedPermissions(selectedPermissions).length > 0"
  >
    <span
      class="ui-kit-dot-separated-item"
      data-qa="options-item"
      *ngFor="
        let item of getDisplayedSelectedPermissions(selectedPermissions);
        trackBy: permissionsTrackBy
      "
      translate
    >
      {{ item }}
    </span>
  </div>

  <button
    data-qa-button="select-options"
    class="ui-kit-button_link"
    (click)="selectPermissions()"
    translate
    type="button"
  >
    group.account.select
  </button>
</div>
